export enum SelectAssetRoutes {
  Search = '/select/search',
  Account = '/select/account',
}
